import(/* webpackMode: "eager" */ "/app/app/[lng]/application/products/new/page.tsx");
